import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography} from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { list } from "../../../controllers/V1/customerDue/dueController";
import moment from "moment";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () =>  togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  
  const handleExport = async (e) => {
    e.preventDefault(0);
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);

      const option = {
        condition : { 
          ...(formData.get('users_name') && {users_name : { $regex: formData.get('users_name'), $options: "i" }}),
          ...(formData.get('last_name') && {last_name : { $regex: formData.get('last_name'), $options: "i" }}),
          ...(formData.get('users_mobile') && {users_mobile : parseInt(formData.get('users_mobile'))}),
          ...(formData.get('users_email') && {users_mobile : formData.get('users_email')}),
          ...(formData.get('store') && {store : { $regex: formData.get('store'), $options: "i" }}),
          ...(formData.get('bind_person_name') && {bind_person_name : { $regex: formData.get('bind_person_name'), $options: "i" }}),
          ...(formData.get('bind_user_type') && {bind_user_type : formData.get('bind_user_type')})
         },
         select : {
          ...(
            formData.get('select_users_id') ||
            formData.get('select_users_type') ||
            formData.get('select_users_name') ||
            formData.get('select_last_name') ||
            formData.get('select_users_mobile') ||
            formData.get('select_users_email') ||
            formData.get('select_store_name') ||
            formData.get('select_bind_person_name') ||
            formData.get('select_bind_user_type') ||
            formData.get('select_pos_number') ||
            formData.get('select_target_collection') ||
            formData.get('select_total_collection') ||
            formData.get('select_target_settlement') ||
            formData.get('select_total_settlement') ||
            formData.get('select_due_amount') ||
            formData.get('select_status') ?({
              ...(formData.get('select_users_id')?{users_id : true}:null),
              ...(formData.get('select_users_type')?{users_type : true}:null),
              ...(formData.get('select_users_name')?{users_name : true}:null),
              ...(formData.get('select_last_name')?{last_name : true}:null),
              ...(formData.get('select_users_mobile')?{users_mobile : true}:null),
              ...(formData.get('select_users_email')?{users_email : true}:null),
              ...(formData.get('select_store_name')?{store_name : true}:null),
              ...(formData.get('select_bind_person_name')?{bind_person_name : true}:null),
              ...(formData.get('select_bind_user_type')?{bind_user_type : true}:null),
              ...(formData.get('select_pos_number')?{pos_number : true}:null),
              ...(formData.get('select_target_collection')?{target_collection : true}:null),
              ...(formData.get('select_total_collection')?{total_collection : true}:null),
              ...(formData.get('select_target_settlement')?{target_settlement : true}:null),
              ...(formData.get('select_total_settlement')?{total_settlement : true}:null),
              ...(formData.get('select_wifi_incentive')?{wifi_incentive : true}:null),
              ...(formData.get('select_old_due_amount')?{old_due_amount : true}:null),
              ...(formData.get('select_due_amount')?{due_amount : true}:null),
              ...(formData.get('select_status')?{status : true}:null),
            }):({
              _id : false,
              __v : false,
              updated_by : false,
              updated_ip : false,
              created_ip : false,
              created_by : false,
              country_code : false,
              password : false,
              token : false
            })
          )
         }
      }
      
      const res = await list(option);
      if(res.status === true){
        let modifiedData = res?.result.map((items, index) => ({
          "Sl. No"            : index + 1,
          "User's Type"       : items?.users_type,
          "First Name"        : items?.users_name,
          "Last Name"         : items?.last_name,
          "Mobile No."        : items?.users_mobile,
          "Email Id"          : items?.users_email,
          "POS No."           : items?.pos_number,
          "Store"             : items?.store_name,
          "Area"              : items?.area,
          'Total B-Points'    : items?.totalArabianPoints,
          'Avl. B-Points'     : items?.availableArabianPoints,
          "Bind With Person"  : items?.bind_person_name,
          "Target collection" : items?.target_collection,
          "Total collection"  : items?.total_collection,
          "Target settlement" : items?.target_settlement,
          "Target settlement" : items?.total_settlement,
          "Wifi Incentive"    : items?.wifi_incentive,
          "Old due amount"    : items?.old_due_amount,
          "Due amount"        : items?.due_amount,
          "Status"            : items?.status
        }));
        if(modifiedData?.length > 0){
          await exportToExcel(modifiedData);
        }
        handleCancel();
      }else{
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Customer list");
      XLSX.writeFile(workbook, `CRM_Users_List ${moment().format('YYYY-MM-DD')}.xlsx`);
    } catch (error) {
      alert(JSON.stringify(error));
    } finally {
      setIsLoading(false);
    }

  };

  const [checkedData, setCheckedData] = useState({});
  const handleChecked = (e) =>{
    try {
      const {name, value} = e.target;
      setCheckedData((prev)=>({
        ...prev,
        [name] : prev[name] === "Y" ? "N" : "Y",
      }))
    } catch (error) {
      
    }
  }
  
  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        
        <div className="myDrawer">
          <div className="inventory_popup_title">
            <Typography
              variant="h5"
              component="div"
              gutterBottom
              className="inventory_popup_title_heading"
            >
              Export customer's due
            </Typography>
            <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}><FontAwesomeIcon icon={faTimesCircle}/></Link>
          </div>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
          </Typography>
         
          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
            <div className="container-fluid">
              <div className="categories_open_popup_main_contnet">
                <form onSubmit={handleExport}>
                  <div className="form-group row">
                    <div className="col-lg-6 col-md-5 col-sm-12 col-xs-12">
                      <label for="users_name" className="all_lable_for_vendor_dashbaord" > First Name : </label>
                      <input type="text" name="users_name" id="users_name" placeholder="Enter first name" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-5 col-sm-12 col-xs-12">
                      <label for="last_name" className="all_lable_for_vendor_dashbaord" > Last Name : </label>
                      <input type="text" name="last_name" id="last_name" placeholder="Enter last first " class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="users_mobile" className="all_lable_for_vendor_dashbaord" > Mobile Number : </label>
                      <input type="number" name="users_mobile" id="users_mobile" placeholder="Enter mobile number" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="users_email" className="all_lable_for_vendor_dashbaord" > Email : </label>
                      <input type="text" name="users_email" id="users_email" placeholder="Enter email" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="bind_person_name" className="all_lable_for_vendor_dashbaord" > Bind Person Name : </label>
                      <input type="text" name="bind_person_name" id="bind_person_name" placeholder="Enter bind person name" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <label for="bind_user_type" className="all_lable_for_vendor_dashbaord" > Bind Person Type : </label>
                      <select name="bind_user_type" id="bind_user_type" className="form-control categories_select_tg_enter_product" >
                        <option value={''} selected disabled>Select bind person type</option>
                        <option value={'BDM'}>BDM</option>
                        <option value={'Manager'}>Manager</option>
                        <option value={'Sales Supervisor'}>Sales Supervisor</option>
                        <option value={'Sales Person'}>Sales Person</option>
                        <option value={'Retailer'}>Retailer</option>
                      </select>
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label for="store" className="all_lable_for_vendor_dashbaord" > Store's Name : </label>
                      <input type="text" name="store" id="store" placeholder="Enter user's store" class="form-control categories_select_tg_enter_product" />
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label for="select_name" className="all_lable_for_vendor_dashbaord" > Export fields (If any) : </label>
                    </div>

                    

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_users_id" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_users_id" id="select_users_id" className="form-check-input" checked={checkedData?.select_users_id !== "Y" ? true : false} onClick={handleChecked} /> User's Id 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_users_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_users_name" id="select_users_name" checked={checkedData?.select_users_name !== "Y" ? true : false} className="form-check-input" /> First Name 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_last_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_last_name" id="select_last_name" checked={checkedData?.select_last_name !== "Y" ? true : false} className="form-check-input" /> Last Name 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_users_type" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_users_type" id="select_users_type" checked={checkedData?.select_users_type !== "Y" ? true : false} className="form-check-input" /> User's type 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_users_mobile" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_users_mobile" id="select_users_mobile" checked={checkedData?.select_users_mobile !== "Y" ? true : false} className="form-check-input" /> Mobile 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_users_email" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_users_email" id="select_users_email" checked={checkedData?.select_users_email !== "Y" ? true : false} className="form-check-input" /> Email
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_pos_number" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_pos_number" id="select_pos_number" checked={checkedData?.select_pos_number !== "Y" ? true : false} className="form-check-input" /> POS number 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_store_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_store_name" id="select_store_name" checked={checkedData?.select_store_name !== "Y" ? true : false} className="form-check-input" /> Store's Name 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_bind_person_name" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_bind_person_name" id="select_bind_person_name" checked={checkedData?.select_bind_person_name !== "Y" ? true : false} className="form-check-input" /> Bind with person name 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_target_collection" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_target_collection" id="select_target_collection" checked={checkedData?.select_target_collection !== "Y" ? true : false} className="form-check-input" /> Target Collection 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_total_collection" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_total_collection" id="select_total_collection" checked={checkedData?.select_total_collection !== "Y" ? true : false} className="form-check-input" /> Total Collection 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_target_settlement" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_target_settlement" id="select_target_settlement" checked={checkedData?.select_target_settlement !== "Y" ? true : false} className="form-check-input" /> Target Settlement 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_total_settlement" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_total_settlement" id="select_total_settlement" checked={checkedData?.select_total_settlement !== "Y" ? true : false} className="form-check-input" /> Total Settlement 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_wifi_incentive" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_wifi_incentive" id="select_wifi_incentive" checked={checkedData?.select_wifi_incentive !== "Y" ? true : false} className="form-check-input" /> Wifi Incentive
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_old_due_amount" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_old_due_amount" id="select_old_due_amount" checked={checkedData?.select_old_due_amount !== "Y" ? true : false} className="form-check-input" /> Old due amount 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_due_amount" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_due_amount" id="select_due_amount" checked={checkedData?.select_due_amount !== "Y" ? true : false} className="form-check-input" /> Due amount 
                      </label>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_status" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_status" id="select_status" checked={checkedData?.select_status !== "Y" ? true : false} className="form-check-input" /> Status 
                      </label>
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="inventory_open_popup_action_btn">
                        <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel} > Cancel </button>
                        <button type="submit" className="btn btn-danger" > Download Excel </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Typography>
        </div>
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
